import { ScanModel } from '../../network';
import { MetricKeyEnum } from '../LayerControls/layerStore';

type ParsedValue = number | null | undefined;

export const parseScan = (
  scan: ScanModel | null
): Partial<Record<MetricKeyEnum, ParsedValue>> | undefined => {
  if (!scan) {
    return undefined;
  }

  const sagittalMetricsEnabled = scan.sagittal_metrics_enabled;
  const featuresetValues = scan.featureset_values?.[0];
  const sagittalDisplayDict = featuresetValues?.sagittal_display_dict;

  const result: Partial<Record<MetricKeyEnum, ParsedValue>> = {};

  if (featuresetValues?.predicted_cobb) {
    result[MetricKeyEnum.AiPredictedCobbAngle] =
      featuresetValues?.predicted_cobb;
  }

  if (featuresetValues?.shoulder_asymmetry) {
    result[MetricKeyEnum.ShoulderAsymmetry] =
      featuresetValues?.shoulder_asymmetry;
  }

  if (featuresetValues?.trunk_shift) {
    result[MetricKeyEnum.TrunkShift] = featuresetValues?.trunk_shift;
  }

  if (featuresetValues?.mesh_metadata?.msl_plane) {
    result[MetricKeyEnum.MidSacralPlane] =
      featuresetValues?.mesh_metadata?.msl_plane;
  }

  // Sagittal metrics are disabled so we can return early
  if (sagittalMetricsEnabled === false) {
    return result;
  }

  if (featuresetValues?.hip_to_ear_angle) {
    result[MetricKeyEnum.HipToEar] = featuresetValues?.hip_to_ear_angle;
  }

  if (sagittalDisplayDict?.leg_angles?.knee_bend_angle) {
    result[MetricKeyEnum.KneeBend] =
      sagittalDisplayDict?.leg_angles?.knee_bend_angle ?? null;
  }

  if (sagittalDisplayDict?.leg_angles?.ankle_flexion_angle) {
    result[MetricKeyEnum.AnkleFlexion] =
      sagittalDisplayDict?.leg_angles?.ankle_flexion_angle ?? null;
  }

  if (sagittalDisplayDict?.max_lower_sagittal) {
    result[MetricKeyEnum.MaxLowerSagittal] =
      sagittalDisplayDict?.max_lower_sagittal?.angle ?? null;
  }

  if (sagittalDisplayDict?.max_upper_sagittal) {
    result[MetricKeyEnum.MaxUpperSagittal] =
      sagittalDisplayDict?.max_upper_sagittal?.angle ?? null;
  }

  if (featuresetValues?.sagittal_balance) {
    result[MetricKeyEnum.SagittalBalancePlane] =
      featuresetValues?.sagittal_balance;
  }

  if (featuresetValues?.sagittal_balance_plane) {
    result[MetricKeyEnum.MidSagittalPlane] =
      featuresetValues?.sagittal_balance_plane;
  }

  return result;
};

export const parsedValueToString = (value: ParsedValue | undefined) => {
  if (!value) {
    return '';
  }

  return value.toFixed(2);
};
